import { createContext, useContext, type ReactNode } from 'react';
import { api as defaultApi } from './index';
import type { MailApi } from './contract';

/**
 * Dependency-injects the `MailApi` implementation.
 *
 * The default value is the app-wide singleton, so nothing changes at runtime —
 * `VITE_USE_MOCKS=true` still swaps in `createMockApi()` exactly as before. What
 * this buys is tests: `createMockApi({ latencyMs: 0 })` is a complete in-memory
 * implementation of the same contract, so a component test renders against real
 * data with no MSW and no hand-written fixtures, and a mutation test can inject
 * an implementation that rejects in order to exercise rollback.
 */
const ApiContext = createContext<MailApi>(defaultApi);

export function ApiProvider({ api, children }: { api?: MailApi; children: ReactNode }) {
  return <ApiContext.Provider value={api ?? defaultApi}>{children}</ApiContext.Provider>;
}

export function useApi(): MailApi {
  return useContext(ApiContext);
}
